

class Adwords {
    constructor(params) {
    
  this.generic = {};
  this.setParameters(params);
  this.isParent = true;
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }else{
                this[prop] = params[prop];
              }
              
          }
      }
    }
    setId(val){
      this.platformId = val;
    }
    setName(val){
      this.name = val;
      this.generic.name = val;
    }
    setPlatformId(val){
      this.platformId = val;
      this.generic.platformId = val;
      this.generic.id = val;
    }
    setManager(val){
      this.generic.subTitle = (val) ? "Manager" : "";
      this.isManager = val;
      this.generic.isManager = val;
    }
}

export default Adwords;
  